<div class='container'>
  <div class='p-3 row'>
    <div class='col'>
      <div class='card my-3'>
        <div class='card-header'>

          <h2>Profile Settings</h2>
        </div>
        <div class='card-body'>

          <p>Display Name: {{ authenticationService.userData?.displayName }}</p>
          <p>Email: {{ authenticationService.userData?.email }}</p>
          <p>Id: {{ authenticationService.userData?.uid }}</p>
        </div>

      </div>

      <div class='card my-3' *ngIf='isInOrg'>
        <div class='card-header'>
          <h2>Organization Settings</h2>

        </div>
        <div class='m-2'>
          <span *ngIf='loading' class='spinner-border mr-1'></span>
        </div>
        <div class='card-body' *ngIf='!loading'>
          <h4 class='card-title'><strong>Organization Name:</strong> {{orgData?.name}}</h4>
          <h4 class='card-title'><strong>Organization ID: </strong>{{orgData?.id}}</h4>
          <div *ngIf='isAdmin || isOrgAdmin'>
            <h4 class='card-title'><strong>Share locations across organization:</strong></h4>
            <label class='switch'>
              <input type='checkbox' [ngModel]='isSharingLocation' (ngModelChange)='handleShareLocation()'>
              <span class='slider round'></span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
